function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ShowSubNodes-1{fill:#f4f4f4;}.ShowSubNodes-2{fill:#37beb7;}.ShowSubNodes-3{fill:#ffbe54;}.ShowSubNodes-4{fill:#16224a;}.ShowSubNodes-5{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_148",
  "data-name": "Group 148"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  className: "ShowSubNodes-1",
  d: "M61.44,42.19A13.19,13.19,0,0,0,52,38.26h0a13.26,13.26,0,1,0,0,26.51h0A13.41,13.41,0,0,0,65.32,51.54,13.16,13.16,0,0,0,61.44,42.19Zm-18,9.3A8.64,8.64,0,0,1,52,42.88h.05a8.49,8.49,0,0,1,6.06,2.55l.26.27a8.47,8.47,0,0,0-5.79-2.29h0A8.64,8.64,0,0,0,44,52a8.47,8.47,0,0,0,2.29,5.79L46,57.54a8.45,8.45,0,0,1-2.55-6Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  className: "ShowSubNodes-1",
  d: "M66.81,38.26a2.12,2.12,0,0,0,2.39-.64l2.12-2.13c1.33-1.27,2.66-2.65,3.93-4A1.88,1.88,0,0,1,77.59,31a8,8,0,0,0,4.73.53,8.86,8.86,0,0,0,7.44-8.87h0a9,9,0,0,0-6-8.45,9.59,9.59,0,0,0-3.14-.53,8.66,8.66,0,0,0-6.21,2.82c-2.6,2.65-3.24,5.84-1.86,9.56a2,2,0,0,1-.48,2.23c-1.43,1.38-2.87,2.82-4.25,4.2l-1.75,1.75c-.75.75-1,1.33-.9,2A2.34,2.34,0,0,0,66.81,38.26Zm11-18.65a4.15,4.15,0,0,1,3-1.22h0a4.69,4.69,0,0,1,2.29.63,6.34,6.34,0,0,0-1.06-.1H82a4.31,4.31,0,0,0-2.12,8,4.39,4.39,0,0,1-3.4-4.25A4.64,4.64,0,0,1,77.81,19.61Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_602",
  "data-name": "Path 602",
  className: "ShowSubNodes-1",
  d: "M18.25,30.13a8.75,8.75,0,0,0,8.29.8,2.47,2.47,0,0,1,.85-.21,1.74,1.74,0,0,1,1.27.63c2,2.08,4,4,5.9,5.95a3.75,3.75,0,0,0,1.17.8,2.25,2.25,0,0,0,2.66-1A2.35,2.35,0,0,0,38,34.22C35.84,32,33.87,30,31.9,28.11A1.9,1.9,0,0,1,31.43,26l.1-.42a12.51,12.51,0,0,0,.59-3,9,9,0,0,0-9.06-8.93h-.51a4.54,4.54,0,0,0-.9.06,9,9,0,0,0-7.49,9,9.23,9.23,0,0,0,4.09,7.43Zm2-10.52A4.28,4.28,0,0,1,25.42,19a4,4,0,0,0-.85-.1,4.26,4.26,0,0,0-4.3,4.22v0a4.31,4.31,0,0,0,2,3.71,4.24,4.24,0,0,1-3.3-4.2,3.94,3.94,0,0,1,1.28-3Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_603",
  "data-name": "Path 603",
  className: "ShowSubNodes-1",
  d: "M19.52,54.94a1.51,1.51,0,0,1,1.7-1.06h3.51v-.06h2.18a30.91,30.91,0,0,0,3.19,0,2.32,2.32,0,1,0-.05-4.63H28c-2.12,0-4.3,0-6.42.05a2.19,2.19,0,0,1-2.29-1.49,8.91,8.91,0,0,0-5.52-4.83,8.51,8.51,0,0,0-2.55-.37,8.79,8.79,0,0,0-4.73,1.38,8.6,8.6,0,0,0-4.15,8.76A9,9,0,0,0,9,60.2C13.31,61.26,18,58.92,19.52,54.94ZM7,51.38a4.2,4.2,0,0,1,1.38-3,4.45,4.45,0,0,1,3.13-1.27,3.49,3.49,0,0,1,1.91.58c-.21-.05-.42-.05-.63-.1a4.24,4.24,0,0,0-3.14,1.27,4.5,4.5,0,0,0-1.38,3,4.28,4.28,0,0,0,2.18,3.82A4.33,4.33,0,0,1,7,51.38Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  className: "ShowSubNodes-1",
  d: "M86,73.06A8.83,8.83,0,0,0,77.49,72a1.82,1.82,0,0,1-2.24-.48q-2.94-3-5.9-5.9a2.84,2.84,0,0,0-1.48-.8c-.11,0-.27,0-.38,0a2.29,2.29,0,0,0-1.48,4l.32.37C68.19,71,70.1,72.94,72,74.8A1.86,1.86,0,0,1,72.49,77a8.89,8.89,0,0,0,3.72,11,9,9,0,0,0,13.6-7.65h0A8.54,8.54,0,0,0,86,73.05Zm-9.56,7.17A4.48,4.48,0,0,1,80.68,76h0a4.58,4.58,0,0,1,2.28.64,5.68,5.68,0,0,0-1-.11h0a4.43,4.43,0,0,0-4.2,4.25,4.59,4.59,0,0,0,1.17,3,6.44,6.44,0,0,0,.9.74,4.64,4.64,0,0,1-2.18-1.22,4.85,4.85,0,0,1-1.17-3.08Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  className: "ShowSubNodes-1",
  d: "M55.6,84.05A2,2,0,0,1,54.32,82c.06-1,0-2,0-3V73.48A2.34,2.34,0,0,0,52.07,71H52a2.34,2.34,0,0,0-2.28,2.42v1.88c0,2.13,0,4.3,0,6.48a2.25,2.25,0,0,1-1.48,2.34,8.48,8.48,0,0,0-5.05,6.59,8.68,8.68,0,0,0,1.65,6.8,9,9,0,0,0,15.3-1.49,8.82,8.82,0,0,0,.31-7A9.25,9.25,0,0,0,55.6,84.05Zm-7.87,8.08A4.34,4.34,0,0,1,52,87.88h.06a4.17,4.17,0,0,1,2.12.58,4,4,0,0,0-.85-.1h0A4.3,4.3,0,0,0,49,92.61a4.46,4.46,0,0,0,2.12,3.77,4.18,4.18,0,0,1-3.39-4.25Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_606",
  "data-name": "Path 606",
  className: "ShowSubNodes-1",
  d: "M48.58,19a1.79,1.79,0,0,1,1.17,1.81c0,2.76,0,5.63,0,8.34v.21a2.84,2.84,0,0,0,.11,1,2.37,2.37,0,0,0,2.5,1.59,2.24,2.24,0,0,0,2-2.23v-.11c0-2.71,0-5.47,0-8.23A2.27,2.27,0,0,1,56,18.81c3.3-1.44,5.31-5.21,5.1-7.65h0c-.26-3.78-1.59-6.22-4.25-8A8.22,8.22,0,0,0,52.2,1.86a9.5,9.5,0,0,0-2.44.32,8.69,8.69,0,0,0-5.58,4.3A8.85,8.85,0,0,0,48.58,19ZM49,7.71a4.56,4.56,0,0,1,3.08-1.28A4.32,4.32,0,0,1,54.22,7a4.13,4.13,0,0,0-.85-.11,4.37,4.37,0,0,0-3.09,1.28,4,4,0,0,0-1.27,3A4.54,4.54,0,0,0,51.13,15a4.35,4.35,0,0,1-3.4-4.3,4,4,0,0,1,1.28-3Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_607",
  "data-name": "Path 607",
  className: "ShowSubNodes-1",
  d: "M37.53,64.87a2.45,2.45,0,0,0-2.87.64c-2,2-4,4-5.95,6a1.8,1.8,0,0,1-2.17.48,8.41,8.41,0,0,0-3.35-.69,8.64,8.64,0,0,0-4,1,8.89,8.89,0,0,0-4.57,10.41,9,9,0,0,0,8.66,6.54h.06a8.84,8.84,0,0,0,7.11-3.62,8.46,8.46,0,0,0,1.44-7.49,3.79,3.79,0,0,1,1.27-4.51c1.38-1.23,2.71-2.6,4-3.94.32-.31.58-.63.9-.9a2.68,2.68,0,0,0,.8-2.23A2.31,2.31,0,0,0,37.53,64.87ZM18.78,80.33a4.34,4.34,0,0,1,1.22-3A4.17,4.17,0,0,1,23,76h0a4.18,4.18,0,0,1,2.28.64,5.68,5.68,0,0,0-1-.11h0a4.31,4.31,0,0,0-2.07,8,4.39,4.39,0,0,1-3.4-4.25Z",
  transform: "translate(-1.46 -1.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_608",
  "data-name": "Path 608",
  className: "ShowSubNodes-1",
  d: "M101.66,50.64a8.76,8.76,0,0,0-3.24-6.11,8.65,8.65,0,0,0-6.48-2A8.8,8.8,0,0,0,84.45,48a1.55,1.55,0,0,1-1.65,1.06c-1-.05-2,0-2.92,0H77.7c-1.33,0-2.66,0-4,.06a2.22,2.22,0,0,0-2.07,2.36v0A2.3,2.3,0,0,0,74,53.72h8.77a1.8,1.8,0,0,1,1.8,1.22,8.61,8.61,0,0,0,7,5.31A8.75,8.75,0,0,0,98.79,58a9,9,0,0,0,2.87-7.38Zm-13.23.85a4.44,4.44,0,0,1,1.33-3.09,4.34,4.34,0,0,1,3-1.27h0a4.24,4.24,0,0,1,2.12.58,4,4,0,0,0-.85-.1h0a4.36,4.36,0,0,0-3,1.27A4.42,4.42,0,0,0,89.7,52a4.5,4.5,0,0,0,2.18,3.72,4.32,4.32,0,0,1-3.45-4.2Z",
  transform: "translate(-1.46 -1.12)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_609",
  "data-name": "Path 609",
  className: "ShowSubNodes-2",
  d: "M14.8,54.35a4.26,4.26,0,0,1-3,1.23h-.11a4.45,4.45,0,0,1-4.2-4.47,4.22,4.22,0,0,1,1.38-3A4.5,4.5,0,0,1,12,46.86a4.4,4.4,0,0,1,4.09,4.36A4.22,4.22,0,0,1,14.8,54.35Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_610",
  "data-name": "Path 610",
  className: "ShowSubNodes-2",
  d: "M20.75,19.34a4.07,4.07,0,0,1,3-1.22A4.35,4.35,0,0,1,28,22.48a4.27,4.27,0,0,1-4.24,4.3h0a4.24,4.24,0,0,1-4.3-4.17v-.19a4.4,4.4,0,0,1,1.28-3.08Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_611",
  "data-name": "Path 611",
  className: "ShowSubNodes-2",
  d: "M49.49,7.44a4.55,4.55,0,0,1,3.08-1.27,4.28,4.28,0,0,1,4.3,4.26,4.23,4.23,0,0,1-1.33,3.12,4.32,4.32,0,0,1-3,1.28h-.06a4.34,4.34,0,0,1-4.25-4.41,4,4,0,0,1,1.23-3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_612",
  "data-name": "Path 612",
  className: "ShowSubNodes-2",
  d: "M78.34,19.34a4.23,4.23,0,0,1,3-1.22h0a4.31,4.31,0,1,1,0,8.61h0a4.28,4.28,0,0,1-4.25-4.3h0A4,4,0,0,1,78.34,19.34Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_613",
  "data-name": "Path 613",
  className: "ShowSubNodes-2",
  d: "M96.24,54.35a4.14,4.14,0,0,1-2.87,1.23h-.05a4.54,4.54,0,0,1-4.41-4.36,4.38,4.38,0,0,1,1.33-3.08,4.31,4.31,0,0,1,3-1.28h0a4.47,4.47,0,0,1,4.3,4.36A4.32,4.32,0,0,1,96.24,54.35Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_614",
  "data-name": "Path 614",
  className: "ShowSubNodes-2",
  d: "M84.34,83.1a4.1,4.1,0,0,1-2.92,1.22h-.06a4.43,4.43,0,0,1-3.24-1.38,4.08,4.08,0,0,1-1.17-3,4.49,4.49,0,0,1,4.2-4.25h.06a4.32,4.32,0,0,1,4.35,4.28v.13a3.74,3.74,0,0,1-1.22,3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_615",
  "data-name": "Path 615",
  className: "ShowSubNodes-2",
  d: "M55.54,95.05a4.34,4.34,0,0,1-3,1.27h-.11a4.3,4.3,0,1,1,.05-8.6h.06a4.39,4.39,0,0,1,4.3,4.3,4.13,4.13,0,0,1-1.28,3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_616",
  "data-name": "Path 616",
  className: "ShowSubNodes-2",
  d: "M26.64,83.2a4,4,0,0,1-2.81,1.22h0a4.32,4.32,0,0,1-3.3-7.33,4.17,4.17,0,0,1,3-1.33h0A4.38,4.38,0,0,1,27.92,80,4.19,4.19,0,0,1,26.64,83.2Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_617",
  "data-name": "Path 617",
  className: "ShowSubNodes-3",
  d: "M51.77,59.83h0a8.61,8.61,0,0,1,0-17.22h.06a8.61,8.61,0,0,1-.06,17.22Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_618",
  "data-name": "Path 618",
  className: "ShowSubNodes-4",
  d: "M51.24,37.46h0a13.26,13.26,0,0,0,0,26.51h0A13.41,13.41,0,0,0,64.52,50.74a12.87,12.87,0,0,0-3.82-9.3,13.31,13.31,0,0,0-9.46-4Zm0,21.89h0a8.61,8.61,0,0,1-.19-17.22h.24a8.71,8.71,0,0,1,8.61,8.66A8.71,8.71,0,0,1,51.24,59.35Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_619",
  "data-name": "Path 619",
  className: "ShowSubNodes-4",
  d: "M66.06,37.46a2.1,2.1,0,0,0,2.39-.64l2.13-2.12c1.33-1.28,2.66-2.66,3.93-4a1.88,1.88,0,0,1,2.34-.48,7.91,7.91,0,0,0,4.73.53A8.87,8.87,0,0,0,89,21.89h0a8.93,8.93,0,0,0-6-8.44,9.34,9.34,0,0,0-3.14-.54,8.68,8.68,0,0,0-6.22,2.82c-2.6,2.66-3.24,5.84-1.86,9.56a2,2,0,0,1-.47,2.23c-1.44,1.39-2.87,2.82-4.25,4.2l-1.76,1.76c-.74.74-1,1.32-.9,2A2.23,2.23,0,0,0,66.06,37.46Zm11-18.65a4.16,4.16,0,0,1,3-1.22h0a4.31,4.31,0,0,1,0,8.61h0a4.28,4.28,0,0,1-4.25-4.3h0a4,4,0,0,1,1.22-3.09Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_620",
  "data-name": "Path 620",
  className: "ShowSubNodes-4",
  d: "M17.51,29.38a8.67,8.67,0,0,0,8.28.8,3.11,3.11,0,0,1,.85-.21,1.77,1.77,0,0,1,1.28.64c2,2.07,4,4,5.9,6a3.64,3.64,0,0,0,1.17.8,2.25,2.25,0,0,0,2.65-1,2.35,2.35,0,0,0-.37-2.87c-2.18-2.23-4.14-4.2-6.11-6.11a1.93,1.93,0,0,1-.48-2.07l.11-.42a12.58,12.58,0,0,0,.58-3,9,9,0,0,0-9.06-8.93h-.5a5.43,5.43,0,0,0-.9.05,9,9,0,0,0-7.49,9,9.2,9.2,0,0,0,4.09,7.44Zm2-10.57a4.09,4.09,0,0,1,3-1.22A4.36,4.36,0,0,1,26.75,22a4.28,4.28,0,0,1-4.25,4.3h0a4.24,4.24,0,0,1-4.3-4.17v-.19a4.59,4.59,0,0,1,1.27-3.08Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_621",
  "data-name": "Path 621",
  className: "ShowSubNodes-4",
  d: "M20.48,53.08H24v0h2.18q1.59,0,3.18-.06a2.32,2.32,0,1,0,0-4.63h-2c-2.12,0-4.3,0-6.43,0a2.18,2.18,0,0,1-2.28-1.48A9,9,0,0,0,13,42.08a8.42,8.42,0,0,0-2.55-.37,9.19,9.19,0,0,0-4.78,1.38,8.61,8.61,0,0,0-4.14,8.77,8.92,8.92,0,0,0,17.11,2.28A1.84,1.84,0,0,1,20.48,53.08Zm-7,.74a4.17,4.17,0,0,1-3,1.22h-.1a4.43,4.43,0,0,1-4.2-4.46,4.2,4.2,0,0,1,1.38-3,4.46,4.46,0,0,1,3.13-1.28,4.4,4.4,0,0,1,4.09,4.36,4,4,0,0,1-1.27,3.13Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_622",
  "data-name": "Path 622",
  className: "ShowSubNodes-4",
  d: "M85.3,72.26a8.85,8.85,0,0,0-8.56-1.06,1.81,1.81,0,0,1-2.23-.48q-2.94-3-5.9-5.9a2.7,2.7,0,0,0-1.49-.8c-.1,0-.26,0-.37,0a2.29,2.29,0,0,0-1.49,4l.32.37c1.86,1.86,3.77,3.83,5.69,5.69a1.87,1.87,0,0,1,.48,2.23,8.88,8.88,0,0,0,3.71,10.94,9,9,0,0,0,13.6-7.65h0A8.65,8.65,0,0,0,85.3,72.26ZM83.07,82.62a4.08,4.08,0,0,1-2.93,1.22h0a4.41,4.41,0,0,1-3.24-1.38,4,4,0,0,1-1.17-3,4.48,4.48,0,0,1,4.2-4.25h.05a4.32,4.32,0,0,1,4.36,4.29v.12a3.74,3.74,0,0,1-1.22,3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_623",
  "data-name": "Path 623",
  className: "ShowSubNodes-4",
  d: "M54.85,83.31a2,2,0,0,1-1.27-2.07c.05-1,0-2,0-3V72.74a2.36,2.36,0,0,0-2.25-2.45h-.09A2.36,2.36,0,0,0,49,72.71a.19.19,0,0,0,0,.08V74.6c0,2.12,0,4.3,0,6.48a2.26,2.26,0,0,1-1.49,2.34A8.48,8.48,0,0,0,42.47,90a8.72,8.72,0,0,0,1.65,6.8,9,9,0,0,0,15.3-1.49,8.82,8.82,0,0,0,.32-7,9.44,9.44,0,0,0-4.89-5Zm-.58,11.21a4.34,4.34,0,0,1-3,1.27h-.1a4.3,4.3,0,1,1,0-8.6h.05a4.38,4.38,0,0,1,4.3,4.3,3.93,3.93,0,0,1-1.27,3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_624",
  "data-name": "Path 624",
  className: "ShowSubNodes-4",
  d: "M47.79,18.23A1.79,1.79,0,0,1,49,20c-.06,2.77,0,5.64,0,8.34v.22a2.77,2.77,0,0,0,.1.95,2.38,2.38,0,0,0,2.5,1.6,2.24,2.24,0,0,0,2-2.23V28.8c0-2.71.05-5.47,0-8.23a2.27,2.27,0,0,1,1.6-2.5c3.29-1.44,5.31-5.21,5.1-7.65h0C60,6.64,58.68,4.2,56,2.45A8.19,8.19,0,0,0,51.4,1.12,9.61,9.61,0,0,0,49,1.44a8.69,8.69,0,0,0-5.58,4.3A9,9,0,0,0,42.8,13a9.21,9.21,0,0,0,5,5.2Zm.42-11.32a4.55,4.55,0,0,1,3.08-1.27,4.33,4.33,0,0,1,0,8.66h0A4.34,4.34,0,0,1,47,9.89a4,4,0,0,1,1.22-3Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_625",
  "data-name": "Path 625",
  className: "ShowSubNodes-4",
  d: "M36.79,64.13a2.45,2.45,0,0,0-2.87.64c-2,2-4,4-6,6a1.81,1.81,0,0,1-2.18.48,8.16,8.16,0,0,0-3.34-.69,8.72,8.72,0,0,0-4,1A8.89,8.89,0,0,0,13.84,82a9,9,0,0,0,8.66,6.53h.05a8.81,8.81,0,0,0,7.12-3.61,8.49,8.49,0,0,0,1.44-7.49,3.79,3.79,0,0,1,1.27-4.52c1.38-1.22,2.71-2.6,4-3.93.32-.32.58-.64.9-.9a2.69,2.69,0,0,0,.8-2.23,2.47,2.47,0,0,0-1.28-1.7ZM25.37,82.72A4,4,0,0,1,22.55,84h0a4.33,4.33,0,0,1-3.29-7.34,4.18,4.18,0,0,1,3-1.32h0a4.35,4.35,0,0,1,4.41,4.25,4.25,4.25,0,0,1-1.27,3.18Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_626",
  "data-name": "Path 626",
  className: "ShowSubNodes-4",
  d: "M97.67,43.78a8.62,8.62,0,0,0-6.48-2,8.84,8.84,0,0,0-7.49,5.53,1.54,1.54,0,0,1-1.65,1.06c-1-.05-2,0-2.92,0H77c-1.32,0-2.65,0-4,0a2.22,2.22,0,0,0-2.07,2.36v0A2.29,2.29,0,0,0,73.24,53H82a1.82,1.82,0,0,1,1.81,1.22,8.64,8.64,0,0,0,7,5.32,8.8,8.8,0,0,0,7.23-2.24,8.91,8.91,0,0,0,.58-12.58,9.15,9.15,0,0,0-1-.91ZM95,53.82A4.09,4.09,0,0,1,92.15,55H92.1a4.53,4.53,0,0,1-4.41-4.35A4.44,4.44,0,0,1,92,46.33h.06a4.48,4.48,0,0,1,4.3,4.36A4.72,4.72,0,0,1,95,53.82Z",
  transform: "translate(-1.46 -1.12)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_627",
  "data-name": "Path 627",
  className: "ShowSubNodes-5",
  d: "M52.62,48.4H49.91a2.27,2.27,0,0,0-2.23,2.31v0A2.3,2.3,0,0,0,49.91,53h2.71a2.35,2.35,0,0,0,2.29-2.29,2.4,2.4,0,0,0-2.29-2.34Z",
  transform: "translate(-1.46 -1.12)"
});

var SvgShowSubNodes = function SvgShowSubNodes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ShowSubNodes1",
    "data-name": "SHowSUbNodes",
    viewBox: "0 0 100.23 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShowSubNodes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShowSubNodes.1e845bd4.svg";
export { ForwardRef as ReactComponent };